// Партнерская программа: реферальные ссылки вида
// {домен}/referal/partner/{partnerReferalId}. Идентификатор запоминается в
// localStorage при открытии сайта по такой ссылке и отправляется на сервер
// при первичном сохранении никнейма (complete-onboarding) — на текущий URL
// при этом не полагаемся: он сбивается редиректами авторизации
export const PARTNER_REFERAL_URL_PREFIX = '/referal/partner/';
export const PARTNER_REFERAL_STORAGE_KEY = 'partnerReferalId';

// Программа «Пригласи друга»: ссылки вида {домен}/referal/friend/{userId},
// идентификатор — id самого пригласившего пользователя. Механика захвата
// и передачи при регистрации — та же, что у партнерских ссылок
export const FRIEND_REFERAL_URL_PREFIX = '/referal/friend/';
export const FRIEND_REFERAL_STORAGE_KEY = 'friendReferalUserId';

// Бонус пригласившему с покупок кристаллов другом (текст на экране
// приглашения; начисление — на сервере при покупке кристаллов)
export const FRIEND_CRYSTALS_PURCHASE_BONUS_PERCENT = 30;
